import React from "react";
import { connect } from "react-redux";
import { setSortAndApply } from "../../core/actions/sorting";
import { SortIcon} from "../icons";
import { tableColWidth } from "../../utils/misc";

const _RegisterTableHead = ({ dispatch, fields, fieldWidths, isEditInterface }) => (
     <thead>
        <tr>
            { fields.map((field) => {

                let thStyle = {
                    width: `${tableColWidth(fieldWidths[field.name])}px`
                };

                return (
                    <th key={ field.name } className="u-pos-relative register-table--header-cell" style={thStyle}>
                        <div className="u-inline-flex u-pr--xxsmall">
                            <div>
                                <button
                                    onClick={ (e) => { e.preventDefault(); dispatch( setSortAndApply(field.name) ) } }
                                    className="btn-reset stretched-link cursor-pointer"
                                >
                                    <SortIcon />
                                </button>
                            </div>
                            <div>{ field.display_name }</div>
                        </div>
                    </th>
                )
            }) }
            { isEditInterface && <th className="register-table-util-column"></th> }
        </tr>
    </thead>
);

const mapStateToProps = (state) => ({
    fields: state.immutableBaseData.fields,
    fieldWidths: state.immutableBaseData.fieldWidths,
    isEditInterface: state.immutableEditing.editingEnabled,
});

export const RegisterTableHead = connect(mapStateToProps)(_RegisterTableHead);

const _RegisterTableHeadSticky = ({ dispatch, fields, fieldWidths, needsOffset, unHide, registerTableWidth, registerTableScrollWrapperWidth }) => {

    let tableStyle = {
        minWidth: registerTableWidth
    };

    return (
        <div className={`wrapper--registers register-fixed-table-header  ${unHide ? "" : "u-hidden"}`}>
            <div className="u-flex table-scroll" style={{width: `${registerTableScrollWrapperWidth}`}}
                 id="register-table-scroll-sticky">
                <div className={`u-flex-grow u-pr--xsmall`}>
                    <div className="table table--compact u-overflow-unset" style={tableStyle}>
                        {fields.map((field, i) => {
                            let colWidth = `${tableColWidth(fieldWidths[field.name])}px`;
                            let thStyle = {
                                width: colWidth,
                                minWidth: colWidth,
                                maxWidth: colWidth,
                            };

                            return (
                                <div
                                    key={field.name}
                                    className={`u-pos-relative register-table--header-cell th ${i === 0 ? `sticky` : ``}`}
                                    style={thStyle}
                                >
                                    <div className="u-inline-flex u-pr--xxsmall">
                                        <div>
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    dispatch(setSortAndApply(field.name))
                                                }}
                                                className="btn-reset stretched-link cursor-pointer"
                                            >
                                                <SortIcon/>
                                            </button>
                                        </div>
                                        <div>{field.display_name}</div>
                                    </div>
                                </div>
                            )
                        })}
                        {needsOffset && (<div
                            className="register-table-util-column th u-pos-relative register-table--header-cell">&nbsp;</div>)}
                    </div>
                </div>
            </div>
        </div>
    )
};

const mapStateToPropsSticky = (state) => ({
    fields: state.immutableBaseData.fields,
    fieldWidths: state.immutableBaseData.fieldWidths,
    needsOffset: state.immutableEditing.editingEnabled,
    registerTableWidth: state.mutableInterface.registerTableWidth,
    registerTableScrollWrapperWidth: state.mutableInterface.registerTableScrollWrapperWidth,
});

export const RegisterTableHeadSticky = connect(mapStateToPropsSticky)(_RegisterTableHeadSticky);

